import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { LinkButton } from "../../components/BasicButton";
import routes from "../../misc/routes";
import AboutDepartmentSelector from './AboutDepartmentSelector';
import './AboutPage.scss';

const AboutPage = () => {
  const { pathname } = useLocation();

  const activeDepartmentInfo = useMemo(() => {
    switch (pathname) {
      case routes.about.children.atletika.path: return {
        title: 'Atlétika szakosztályról',
        galleryUrl: routes.gallery.children.atletika.path,
        docsUrl: routes.documents.children.atletika.path
      };
      case routes.about.children.kezilabda.path: return {
        title: 'Kézilabda szakosztályról',
        galleryUrl: routes.gallery.children.kezilabda.path,
        docsUrl: routes.documents.children.kezilabda.path
      };
      case routes.about.children.labdarugas.path: return {
        title: 'Labdarúgó szakosztályról',
        galleryUrl: routes.gallery.children.labdarugas.path,
        docsUrl: routes.documents.children.labdarugas.path
      };
      case routes.about.children.roplabda.path: return {
        title: 'Röplabda szakosztályról',
        galleryUrl: routes.gallery.children.roplabda.path,
        docsUrl: routes.documents.children.roplabda.path
      };
      case routes.about.children.tollaslabda.path: return {
        title: 'Tollaslabda szakosztályról',
        galleryUrl: routes.gallery.children.tollaslabda.path,
        docsUrl: routes.documents.children.tollaslabda.path
      };
      case routes.about.children.uszas.path: return {
        title: 'Báthory Vízi sportkörről',
        galleryUrl: routes.gallery.children.uszas.path,
        docsUrl: routes.documents.children.uszas.path
      };
      default: return null;
    }
  }, [ pathname ]);

  return (
    <div className="about-page-container">
      <AboutDepartmentSelector />
      <div className='about-content'>
        <h1>{ !!activeDepartmentInfo ? activeDepartmentInfo.title : 'Bemutatkozás' }</h1>
        { !activeDepartmentInfo ? null : (
          <div className="about-content-department-links">
            <LinkButton text="Galéria" to={ activeDepartmentInfo.galleryUrl } />
            <LinkButton text="Dokumentumok" to={ activeDepartmentInfo.docsUrl } />
          </div>
        ) }
      </div>
    </div>
  );
};

export default AboutPage;
